import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import VueNumber from "vue-number-animation";
import { useTheme } from './composables/useTheme'
import './assets/css/in.css'
import 'vue3-lottie/dist/style.css'

const { initTheme } = useTheme()
initTheme()

const app = createApp(App)
app.use(router)
app.use(VueNumber)
app.mount('#app')
